import { Component, Input } from '@angular/core';

@Component({
  template: require('./expander.component.html')
})
export class ExpanderComponent {
  @Input() isExpandable ?: boolean | (( row ) => boolean);
  @Input() record        : any;

  getIcon () : string {
    return this.record.expanded
      ? 'chevron-down'
      : 'chevron-up';
  }

  _isExpandable () : boolean {
    return typeof this.isExpandable === 'function'
      ? this.isExpandable(this.record)
      : this.isExpandable !== false;
  }
}
